import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PATHS, TERMINALS } from '../../../constants';
import { useUpdatePageGroups } from '../../../hooks';
import { SideBarPageGroups } from '../../../types/enums';
import { PageGroupProps, StyledControlledCollapse, StyledDocumentIcon, StyledNavLink } from './GeneralPageGroup.styles';
import { TitleIconRow } from './TitleIconRow';

const DocumentsPageGroup = ({ isExpanded }: PageGroupProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { openPageGroups, updateOpenPageGroups } = useUpdatePageGroups();

  const isDocumentsCollapseOpen = isExpanded && openPageGroups.includes(SideBarPageGroups.Documents);

  return (
    <StyledControlledCollapse
      title={
        <TitleIconRow
          icon={<StyledDocumentIcon $isExpanded={location.pathname.includes(TERMINALS.ParentGroups.Documents)} />}
          title={t('documentRepository.title')}
          $isExpanded={isExpanded}
          open={isDocumentsCollapseOpen}
          $isActive={location.pathname.includes(TERMINALS.ParentGroups.Documents) && isExpanded}
        />
      }
      onClick={() => updateOpenPageGroups(SideBarPageGroups.Documents)}
      open={isDocumentsCollapseOpen}
      $isExpanded={isExpanded}
      $isActive={location.pathname.includes(TERMINALS.ParentGroups.Documents) && isExpanded}
    >
      <StyledNavLink to={PATHS.Documents.Policies.ROOT}>{t('policies.title')}</StyledNavLink>
      <StyledNavLink to={PATHS.Documents.ExecutiveReports.ROOT}>{t('executiveReport.title')}</StyledNavLink>
      <StyledNavLink to={PATHS.Documents.SecurityReports.ROOT}>{t('securityReports.title')}</StyledNavLink>
      <StyledNavLink to={PATHS.Documents.Uploads.ROOT}>{t('documentRepository.uploads')}</StyledNavLink>
    </StyledControlledCollapse>
  );
};

export default DocumentsPageGroup;
